export enum NoteModalComponentLocators {
	subjectField = 'subjectField',
	noteField = 'noteField',
	cancelButton = 'cancelButton',
	saveButton = 'saveButton',
}
